module.exports = __webpack_public_path__ + "static/media/google-play-badge.56b44686.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/google-play-badge.svg
// module id = 74
// module chunks = 0